"use strict";

// plugins
const { each } = require("lodash");
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import { SwalMessage, ToastMessage } from './Tools'
import './DarkMode'
import './Profile'
import './Auth'
import './Captcha'
import './FormRequests'
import './FavoritesAndTrackingList'
import './Hotel'
import './HotelSearching'
import './Tour'

// pwa - service worker
if (!navigator.serviceWorker.controller) {
    navigator.serviceWorker.register("/sw.js").then(function (reg) {
        console.log("Service worker has been registered for scope: " + reg.scope);
    });
}


// ajax
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


// initial
var Init = function () {

    var Load = function () {
        console.log('Powered by Osman Yavuz');

        // tooltip
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

        // .carousel-inner .carousel-item
        $(".carousel-inner .carousel-item").ripples({
            dropRadius: 40,
            perturbance: 0,
            resolution: 256,
            interactive: true
        });

    }

    return {
        init: function () {
            Load();
        },
    };

}();



$(function () {

    Init.init();

});

